import { fredSeriesCode } from "@inrev/common";
import * as z from "zod";

/** What `list_market_series` lists and `get_market_series` repeats beside each series' points. */
export const marketSeriesSchema = z.strictObject({
	seriesCode: fredSeriesCode,
	label: z.string(),
	description: z.string(),
	group: z.string(),
	units: z.string(),
	frequency: z.string(),
	seasonalAdjustment: z.string(),
});
